export default function Avatar({ url, name = "", size = 40 }) {
  const initials = (name || "?")
    .split(" ")
    .map((s) => s[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
  if (url) {
    return (
      <img
        src={url}
        alt={name}
        style={{ width: size, height: size }}
        className="object-cover rounded-full border border-[#262626]"
      />
    );
  }
  return (
    <div
      style={{ width: size, height: size }}
      className="rounded-full bg-[#1a1a1a] border border-[#262626] flex items-center justify-center text-white font-semibold"
    >
      <span style={{ fontSize: size * 0.4 }}>{initials}</span>
    </div>
  );
}
